import { useState } from 'react';
import { useLocation } from "react-router-dom";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import OrderForm from './OrderForm';
import PaymentForm from './PaymentForm';
import axios from '../../../api/axios';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';

const OrderCreate = () => {
    const axiosPrivate = useAxiosPrivate();
    const [clientSecret, setClientSecret] = useState('');
    const [paymentIntent, setPaymentIntent] = useState();
    const [orderData, setOrderData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [stripePromise, setStripePromise] = useState(loadStripe(process.env.REACT_APP_STRIPE_PK));
    const location = useLocation();
    const orderId = location.state?.orderid;

    const handleOrderSubmit = async (data) => {
        const response = await axiosPrivate.post(`v1/tenant/order`, { ...data, quotationStep: 5 })
            .then(res => {
                setIsLoading(false);
            }).catch(error => {
                toast.error("An error occured while saving !", {
                    position: "top-right",
                });
                console.log(error);
                setIsLoading(false);
            });
        // const { clientSecret } = await res.json();
        setOrderData(data);
        await axiosPrivate.get(`v1/tenant/payment-intent/${data.id}`).then(res => {
            setClientSecret(res.data.clientSecret);
            setPaymentIntent(res.data);
            // props.updateFields({ intent: res.data });
        });


        // setClientSecret(clientSecret);
    };

    const handleSaveAsDraft = async (data) => {
        const response = await axiosPrivate.post(`v1/tenant/order`, { ...data, quotationStep: 4 })
            .then(res => {
                toast.success("Your order saved as draft!", {
                    position: "top-right",
                });
                setIsLoading(false);
            }).catch(error => {
                toast.error("An error occured while saving !", {
                    position: "top-right",
                });
                setIsLoading(false);
            });
    }

    const createPaymentIntent = async () => {

    }

    return (
        <div className="container mt-4 mb-4">
            {/* {!clientSecret ? (
                <OrderForm onSubmit={handleOrderSubmit} />
            ) : (
                <Row>
                    <div className="checkout-form border p-4 rounded">
                        <Elements stripe={stripePromise} options={{ clientSecret }}>
                            <PaymentForm orderData={orderData} clientSecret={clientSecret} />
                        </Elements>
                    </div></Row>
            )} */}
            <Row className='mb-4'>
                <Col>
                    <OrderForm onSubmit={handleOrderSubmit} onSaveAsDraft={handleSaveAsDraft} orderId={orderId} />
                </Col>
            </Row>
            {/* 
            {clientSecret &&
                <Row form>
                    <div className="checkout-form border p-4 rounded">
                        <Elements stripe={stripePromise} options={{ clientSecret }}>
                            <PaymentForm orderData={orderData} totalAmount={paymentIntent.totalAmount} clientSecret={clientSecret} />
                        </Elements>
                    </div></Row>
            } */}

            {paymentIntent?.clientSecret &&
                <Row form>
                    <div className="checkout-form border p-4 rounded">
                        <Elements stripe={stripePromise} options={{ clientSecret: paymentIntent.clientSecret }}>
                            <PaymentForm orderData={orderData} totalAmount={paymentIntent.totalAmount} clientSecret={paymentIntent.clientSecret} />
                        </Elements>
                    </div></Row>
            }
        </div>
    );
}

export default OrderCreate;